import { render, staticRenderFns } from "./ModificarCategorias.vue?vue&type=template&id=a5fe0812&scoped=true&"
import script from "./ModificarCategorias.vue?vue&type=script&lang=js&"
export * from "./ModificarCategorias.vue?vue&type=script&lang=js&"
import style0 from "./ModificarCategorias.vue?vue&type=style&index=0&id=a5fe0812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fe0812",
  null
  
)

export default component.exports